export const occasion = {
  common: {
    brand: 'OVERHEAR',
    backToLanding: 'Back',
    back: 'Back',
    copy: 'Copy link',
    copied: 'Copied!',
    continue: 'Continue',
    createMap: 'Create a map',
    downloadApp: 'Download the OVERHEAR app',
  },
  memorial: {
    landingTitle: 'Memories',
    landingTagline: 'Voice messages left in meaningful places.',
    landingDescription:
      'Invite friends and family to leave recordings at a meaningful location — then collect them in the OVERHEAR app.',
    createCta: 'Create a memorial map',
    priceHint: 'One-off — guests contribute free',
    tryDemo: 'Try the app demo',
    crossLink: 'Creating a celebration map instead?',
    crossLinkHref: 'https://celebrate.theoverhear.app',
    howItWorksTitle: 'How it works',
    howItWorks: [
      'Choose a place that mattered to your loved one — a park, street, or landmark — and set the location on the map.',
      'Share a link so friends and family can leave voice messages from their browser.',
      'Share the collect page with the family. They open OVERHEAR, enter the access code, and gather the messages on location.',
    ],
    photoCredit:
      'Photo: Pathway through Park Wood, Ruislip — Harrison49 / Wikimedia Commons (CC BY-SA 3.0)',
    photoAlt: 'Pathway through woodland in Ruislip Woods Nature Reserve',
    wizardTitle: 'Create a memorial map',
    namesLabel: 'Name',
    namesPlaceholder: 'Grandma',
    datesLabel: 'Years (optional)',
    datesPlaceholder: '1946 – 2026',
    headlinePreview: 'Preview',
    placeLabel: 'Place name',
    placePlaceholder: 'Favourite park',
    placeSearchPlaceholder: 'Search for a place or address',
    radiusLabel: 'Collection radius (metres)',
    contributePrompt: 'Leave a memory of {{name}}',
    contributeSuccess: 'Thank you. Your message has been added to the map.',
  },
  celebration: {
    landingTitle: 'Celebrations',
    landingTagline: 'Messages they collect in a place that matters.',
    landingDescription:
      'Geofence a favourite place, invite friends and family to leave voice messages, and let the couple or guest of honour collect them in the OVERHEAR app.',
    createCta: 'Create a celebration map',
    priceHint: 'One-off — guests contribute free',
    tryDemo: 'Try the app demo',
    crossLink: 'Creating a memorial map instead?',
    crossLinkHref: 'https://memories.theoverhear.app',
    howItWorksTitle: 'How it works',
    howItWorks: [
      'Pick a meaningful place — a park, street, or landmark — and set the location on the map.',
      'Invite friends and family to record messages from their browser — no app required.',
      'Share the collect page with the couple or guest of honour so they can open OVERHEAR and enter their access code.',
    ],
    photoCredit:
      'Photo: Confetti (5879576562) — nathanmac87 / Wikimedia Commons (CC BY 2.0)',
    photoAlt: 'Confetti falling during a celebration',
    wizardTitle: 'Create a celebration map',
    namesLabel: 'Names',
    namesPlaceholder: 'The Happy Couple',
    datesLabel: '',
    datesPlaceholder: '',
    headlinePreview: 'Preview',
    placeLabel: 'Place name',
    placePlaceholder: 'Favourite park',
    placeSearchPlaceholder: 'Search for a place or address',
    radiusLabel: 'Collection radius (metres)',
    contributePrompt: 'Leave a message for {{name}}',
    contributeSuccess: 'Thank you. Your message has been added to the map.',
  },
  workshop: {
    landingTitle: 'Workshop maps',
    landingTagline: 'Maps for workshop participants.',
    landingDescription:
      'Each participant creates a private map and invites others to leave voice messages for someone special.',
    createCta: 'Create workshop map',
    priceHint: 'Free for workshop participants',
    tryDemo: 'Try the app demo',
    crossLink: '',
    crossLinkHref: '',
    howItWorksTitle: 'How it works',
    howItWorks: [
      'Open your personal invite and sign in with the email you were invited on.',
      'Name who the map is for, add a pin photo, and draw the place.',
      'Share your contribute link so others can leave voice messages, and share the collect code with the recipient.',
    ],
    photoCredit: '',
    photoAlt: 'Workshop map',
    wizardTitle: 'Create your workshop map',
    namesLabel: 'Who is this map for?',
    namesPlaceholder: 'Name',
    datesLabel: '',
    datesPlaceholder: '',
    headlinePreview: 'Preview',
    placeLabel: 'Place name',
    placePlaceholder: 'Favourite park',
    placeSearchPlaceholder: 'Search for a place or address',
    radiusLabel: 'Collection radius (metres)',
    contributePrompt: 'Leave a message for {{name}}',
    contributeSuccess: 'Thank you. Your message has been added to the map.',
  },
  auth: {
    title: 'Sign in to continue',
    description: 'Create an account or sign in so you can manage your map and share links.',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm password',
    signIn: 'Sign in',
    signUp: 'Create account',
    switchToSignUp: 'Need an account? Create one',
    switchToSignIn: 'Already have an account? Sign in',
    passwordMismatch: "Passwords don't match",
    welcomeTitle: 'Your account is ready',
    welcomeBody:
      'Use the same sign-in method in the OVERHEAR app — email and password, Google, or Apple — to manage maps and collect messages on location.',
    welcomeContinue: 'Continue',
    downloadApp: 'Download the OVERHEAR app',
  },
  wizard: {
    stepNames: 'Who is this for?',
    stepPlace: 'Where should people collect the messages?',
    stepConfirm: 'Confirm and create',
    search: 'Search',
    dropPinHint:
      'Search for a place, then tap the map to drop boundary markers. Drag them to enclose the area — at least three points.',
    undoPoint: 'Undo point',
    clearBoundary: 'Clear boundary',
    boundaryReady: '{{count}} boundary points — drag to reshape',
    boundaryNeedMore: 'Add {{count}} more point(s) to close the area',
    boundaryMax: '(Maximum reached)',
    boundarySummary: '{{count}} boundary points · {{radius}}m collection cover',
    placementModeTitle: 'How should messages be placed?',
    placementModeGuestTitle: 'Friends and family choose a spot',
    placementModeGuestHelp:
      'Contributors place their own pin anywhere inside the area. Each message gets its own location.',
    placementModeOrganiserTitle: 'You place the pins',
    placementModeOrganiserHelp:
      'You drop named pins on the map. Contributors pick a pin — multiple messages at the same pin stack together.',
    memorialPinImageLabel: 'Person image for map pins',
    celebrationPinImageLabel: 'Celebration image for map pins',
    workshopPinImageLabel: 'Photo for map pins',
    pinImageHelp:
      'Your photo is fitted into the pin centre and exported as the map icon, inside the outer border.',
    pinImageCta: 'Upload image',
    pinImageChangeCta: 'Change image',
    pinImageEditCta: 'Edit image',
    pinImageCancelEdit: 'Cancel',
    pinImagePreviewAlt: 'Pin image preview',
    pinImageScale: 'Photo size: {{scale}}%',
    pinImageDragHelp: 'Drag the photo on the preview to reposition it.',
    generatingPinPreview: 'Generating pin preview…',
    workshopStepNames: 'Who is this map for?',
    workshopStepPlace: 'Where should messages be collected?',
    workshopStepConfirm: 'Confirm and create your map',
    workshopPlacementModeTitle: 'How should messages be placed?',
    workshopPlacementModeGuestTitle: 'Contributors choose a spot',
    workshopPlacementModeGuestHelp:
      'People you invite place their own pin anywhere inside the area. Each message gets its own location.',
    workshopPlacementModeOrganiserTitle: 'You place the pins',
    workshopPlacementModeOrganiserHelp:
      'You drop named pins on the map. Contributors pick a pin — multiple messages at the same pin stack together.',
    workshopDropPinHint:
      'Search for a place, then tap the map to drop boundary markers. Drag them to enclose the area — at least three points.',
    create: 'Create map',
    creating: 'Creating your map…',
    payAndCreate: 'Pay {{price}} and create map',
    payAndCreateFallback: 'Pay and create map',
    createFreeMap: 'Create map',
    creatingMap: 'Creating map…',
    redirectingToPayment: 'Redirecting to payment…',
    priceLine: 'One-off payment of {{price}} — friends and family contribute free.',
    checkoutCanceled: 'Payment was canceled. You can try again when you are ready.',
    pinImageAlreadyUploaded: 'Your pin image from the previous attempt is ready. Upload a new one to replace it.',
    paymentSuccessTitle: 'Payment received',
    finalisingPayment: 'Confirming your payment…',
    waitingForMap: 'Creating your map…',
    backToWizard: 'Back to create',
    missingLocation: 'Please draw a boundary with at least three points on the map.',
    missingNames: 'Please enter a name.',
    missingPinImage: 'Please upload an image for the map pins.',
  },
  manage: {
    title: 'Your map',
    guestLink: 'Friends and family contribute link',
    recipientLink: 'Recipient collect page',
    guestLinkHelp: 'Share this with friends and family so they can leave voice messages from a browser.',
    recipientLinkHelp:
      'Share this page with the intended recipients. It shows their access code and a button to open OVERHEAR.',
    recipientCode: 'Access code',
    recipientCodeHelp:
      'Recipients enter this code in the app after sign-in to unlock the private map.',
    regenerateClaimCode: 'Regenerate access code',
    regenerateClaimCodeHelp:
      'Creates a new code and deactivates the old one. Update anyone you already shared with.',
    noClaimCode: 'No access code yet. Regenerate one to invite recipients.',
    submissionCount: '{{count}} message(s) on the map',
    regenerate: 'Regenerate friends and family link',
    revoke: 'Revoke friends and family link',
    regenerateConfirmTitle: 'Regenerate this link?',
    regenerateConfirmMessage:
      'The current friends and family link will stop working. Anyone with the old link will need the new one.',
    regenerateConfirmAction: 'Regenerate link',
    revokeConfirmTitle: 'Revoke this link?',
    revokeConfirmMessage:
      'Friends and family will no longer be able to contribute with this link. You can create a new link later.',
    revokeConfirmAction: 'Revoke link',
    regenerateClaimCodeConfirmTitle: 'Regenerate access code?',
    regenerateClaimCodeConfirmMessage:
      'The current access code will stop working. Update anyone you already shared it with.',
    regenerateClaimCodeConfirmAction: 'Regenerate code',
    noGuestLink: 'No active friends and family link. Regenerate one to invite contributors.',
    notOwner: 'You can only manage maps you created.',
    signInRequired: 'Sign in to manage this map.',
    contributionsTitle: 'Messages on the map',
    contributionsHelp:
      'See who contributed and where each message was placed. Flagged messages need your review after transcription. Listen to messages and delete any that should not stay on the map.',
    noContributions: 'No messages yet. Share the friends and family link to invite contributors.',
    approve: 'Approve',
    reject: 'Reject',
    deleteContribution: 'Delete message',
    deleteContributionTitle: 'Delete this message?',
    deleteContributionMessage:
      'This permanently removes the recording from the map. This cannot be undone.',
    deleteGuestContributionMessage:
      'This permanently removes the recording, and the pin the contributor placed, from the map. This cannot be undone.',
    deleteContributionAction: 'Delete message',
    deleteContributionFailed: 'Could not delete this message. Please try again.',
    listenLabel: 'Listen to message',
    noAudio: 'Audio is not available for this message yet.',
    flaggedNote: 'Flagged: {{phrases}}',
    flaggedBanner: 'Needs review — moderation flags found',
    status: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      flagged: 'Needs review',
    },
    placementModeGuest: 'Friends and family place their own pins inside the area.',
    placementModeOrganiser: 'You place pins; friends and family choose which pin to add their message to.',
    dropPinsTitle: 'Message pins',
    dropPinsHelp:
      'Add named pins inside the area. Friends and family pick one of these — recordings at the same pin stack together.',
    dropPinName: 'Pin name',
    dropPinNamePlaceholder: 'e.g. Bench by the lake',
    dropPinHint: 'Tap inside the area to place a pin, then name it.',
    addDropPin: 'Add pin',
    dropPinRequired: 'Name the pin and place it inside the area.',
    noDropPins: 'No pins yet. Add at least one so friends and family can contribute.',
    backToMaps: 'Your maps',
    pinIconTitle: 'Map pin icon',
    pinIconSave: 'Save new icon',
    pinIconSaving: 'Saving icon…',
    pinIconEditUnavailable:
      'This map was saved before edit support. Upload the photo again to reposition or resize it.',
  },
  myMaps: {
    title: 'Your maps',
    help: 'Memorial and celebration maps you have created. Open one to manage it, or create another map — each new map needs its own payment.',
    empty: 'You have not created any memorial or celebration maps yet.',
    manageMap: 'Manage map',
    deleteMap: 'Delete map',
    deleteConfirmTitle: 'Delete this map?',
    deleteConfirmMessage:
      'This permanently removes the map, all messages, share links, and access codes. This cannot be undone.',
    signInRequired: 'Sign in to view and manage your maps.',
    viewAll: 'Manage your maps',
    typeMemorial: 'Memorial',
    typeCelebration: 'Celebration',
  },
  contribute: {
    title: 'Leave a message',
    invalidLink: 'This link is no longer valid or has expired.',
    yourName: 'Who is this message from?',
    yourNamePlaceholder: 'Your name',
    nameRequired: 'Please say who this message is from.',
    record: 'Record',
    upload: 'Or upload an audio file',
    send: 'Send message',
    sending: 'Sending…',
    sendAnother: 'Send another message',
    successTitle: 'Message sent',
    successThanks: 'Thank you, {{name}}. Your message is on the map.',
    messageFrom: 'From {{name}}',
    createAccountCta: 'Create an account',
    createAccountHelp:
      'Save your message to an OVERHEAR account so you can find it again in the app.',
    accountCreated: 'Account created — you can use the same login in the OVERHEAR app.',
    skipAccount: 'Maybe later',
    appPrompt: 'Recipients collect these messages by walking the place in the OVERHEAR app.',
    appDownloadTitle: 'Get OVERHEAR for yourself',
    appDownloadBody:
      'Download the app to explore audio walks, leave messages in the world, and collect stories wherever you go.',
    placeHint: 'Tap inside the highlighted area to place your message on the map. Drag the marker to adjust.',
    placeRequired: 'Please place your message inside the area on the map.',
    placeOutside: 'That spot is outside the area — tap inside the boundary.',
    pickPinHint: 'Choose a pin on the map for your message. If others pick the same pin, messages stack there.',
    pickPinRequired: 'Please choose a pin for your message.',
    noPinsYet: 'The organiser has not added any pins yet. Please check back later.',
    pause: 'Pause',
    resume: 'Resume',
    paused: 'Paused',
    redo: 'Redo recording',
  },
  collect: {
    invalidCode: 'This collect link is no longer valid.',
    howTitle: 'How to collect',
    openApp: 'Open OVERHEAR',
    codeLabel: 'Your access code',
    codeHelp:
      'After you sign in, enter this code in the app to unlock the private map.',
    needApp: 'Need the app?',
    steps: [
      'Open the OVERHEAR app with the button below.',
      'Read the greeting, then create an account or sign in.',
      'Enter the access code shown on this page.',
      'Visit the place on the map to collect the voice messages.',
    ],
    memorial: {
      eyebrow: 'A private memorial map',
      intro:
        'Messages have been left for you in a place that mattered. Open OVERHEAR and use your access code to collect them.',
    },
    celebration: {
      eyebrow: 'A private celebration map',
      intro:
        'Friends and family have left voice messages for you in a special place. Open OVERHEAR and use your access code to collect them.',
    },
    workshop: {
      eyebrow: 'A private workshop map',
      intro:
        'Messages have been left for you in a special place. Open OVERHEAR and use your access code to collect them.',
    },
  },
  errors: {
    createFailed: 'Could not create the map. Please try again.',
    checkoutFailed: 'Could not start payment. Please try again.',
    checkoutMissingOrder: 'Missing payment order. Please start again from the create page.',
    checkoutFulfilFailed:
      'Payment may have succeeded, but we could not finish creating your map. Please contact support or try opening My Maps.',
    loadFailed: 'Could not load this map.',
    contributeFailed: 'Could not send your message. Please try again.',
    authFailed: 'Authentication failed. Please try again.',
    copyFailed: 'Could not copy the link.',
    claimCodeFailed: 'Could not update the access code. Please try again.',
    deleteFailed: 'Could not delete this map. Please try again.',
  },
};
